import {Feature, FeaturedObject, SelectedFeature} from "@k/js/product";
import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";
import {SelectedFeatureFromProductGetter} from "@k/js/SelectedFeatureFromProductGetter";
import {createProduktPHPParameters, loadproduktPhpAndRegisterResource} from "@k/global/produktphpConnector";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {ResourceInvalidationTriggers} from "@k/global/resourcemanager/resourceManager";
import {ProduktWechselDataInteractor} from "@km/components/productChange/ProduktWechselDataInteractor";
import globalsObject from "@k/js/globalsObject";
import {ProduktAuswahlProdukt} from "@km/store/ProduktAuswahlStore";
import {ref} from "vue";

// @ts-ignore
export const featuresZurAuswahl = ref([]) as Ref<FeaturedObject[]>;
// @ts-ignore
export const currentlySelectedFeatures = ref([]) as Ref<string[]>;

export class Produktwechsel {
    private static interactor: ProduktWechselDataInteractor;
    private static displayArtikel: (produkt:ProduktAuswahlProdukt) => void;

    public static init(interactor:ProduktWechselDataInteractor, displayArtikel:(produkt:ProduktAuswahlProdukt)=>void) {
        Produktwechsel.interactor = interactor;
        Produktwechsel.displayArtikel = displayArtikel;

    }

    public static hasChoosableFeatures(productname:string):boolean {
        return Produktwechsel.interactor.getChoosableFeatures(productname).length > 0;
    }

    public static productChosen = (productname: string) => {
        const product = Produktwechsel.interactor.getAuswahlProdukt(productname) ;
        if(product.isArtikel && product.ArtikelWirdImIFrameDargestellt) {
            // store.commit("STAGE_AUSWAHLPRODUKT", product);
            Produktwechsel.displayArtikel(product);
            return;

        }
        if (!Produktwechsel.hasChoosableFeatures(productname)) {
            Produktwechsel.changeproductWithoutChoosableFeatures(productname)
            return;
        }
        Produktwechsel.stageProductWithChoosableFeatures(productname, SelectedFeatureFromProductGetter.getSelectedFeatures(product, Produktwechsel.interactor.getCurrentOwayoProduct()));
    }

    public static stageProductWithChoosableFeatures(productname:string, selectedFeatures:SelectedFeature[]) {

        const product = Produktwechsel.interactor.getAuswahlProdukt(productname);

        const data = createProduktPHPParameters(
            product,
            selectedFeatures,

            Produktwechsel.interactor.getWebsportFuerProduktAuswahlNormalized(),
            Produktwechsel.interactor.getLanguage(),
            Produktwechsel.interactor.getOwayoDirectLogin()
        );
        loadproduktPhpAndRegisterResource(data, ".stage").then(response=>{
            Produktwechsel.interactor.stageProduct(product, selectedFeatures, response)
            Produktwechsel.interactor.loadProductPreviewPic();
            currentlySelectedFeatures.value = SelectedFeatureFromProductGetter.getSelectedFeatures(product, Produktwechsel.interactor.getStagedProduct()).map(f=>f.name);
        })
        featuresZurAuswahl.value = Produktwechsel.interactor.getChoosableFeatures(productname);
        Produktwechsel.interactor.openPopup(OverlayNames.produktlisteFeatures);
    }

    private static changeproductWithoutChoosableFeatures(productname:string) {

        globalsObject.googleTracker.trackPageview("konfitrack-produktwechsel")
        const product = Produktwechsel.interactor.getAuswahlProdukt(productname);
        const selectedFeatures = SelectedFeatureFromProductGetter.getSelectedFeatures(product, Produktwechsel.interactor.getCurrentOwayoProduct())
        Produktwechsel.interactor.closePopup(OverlayNames.produktliste);
        EventVerteiler.resourceManager.executeInvalidation(ResourceInvalidationTriggers.PRODUCTCHANGE);
        globalsObject.productController.generateOwayoProduct(productname, selectedFeatures).then(() => {
            if (Produktwechsel.interactor.getStagedProductModel() !== Produktwechsel.interactor.getEntwurfModel()) {
                globalsObject.productController.loadOwayoProduct(product.Produkt);
            } else {
                Produktwechsel.updateTitelTagWOProductChange();
            }
        })
    }

    static changeSelectedFeature(featuredObjectname: string, feature: Feature) {
        globalsObject.googleTracker.trackPageview("featurewechsel.htm");
        Produktwechsel.interactor.setStagedFeature({featuredObjectname, feature})
        globalsObject.productController.generateOwayoProduct(Produktwechsel.interactor.getStagedAuswahlProdukt().Produkt, Produktwechsel.interactor.getStagedProductSelectedFeatures());
    }

    private static updateTitelTagWOProductChange() {
        Produktwechsel.interactor.useStagedProductAsCurrentProduct();
        EventVerteiler.broadcast("updateTitelTagEvent", {
            product: Produktwechsel.interactor.getCurrentOwayoProduct(),
            design: Produktwechsel.interactor.getCurrentDesigname()
        });
        EventVerteiler.broadcast("ProductChangedEvent");
    }

    static createProduct() {
        // EventVerteiler.resourceManager.executeInvalidation(ResourceInvalidationTriggers.PRODUCTCHANGE);
        globalsObject.googleTracker.trackPageview("konfitrack-produktwechsel")
        globalsObject.productController.loadOwayoProduct(Produktwechsel.interactor.getStagedProduct().produkt);
        currentlySelectedFeatures.value = [];
        featuresZurAuswahl.value=[];
        Produktwechsel.interactor.closePopup(OverlayNames.produktliste);
        Produktwechsel.interactor.closePopup(OverlayNames.produktlisteFeatures);
    }
}